module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c5849636045196cf49c2a738e7a002a5.png";